  $(document).ready(function() {


var scroll_start = 0;
   var startchange = $('.startchange');
   var offset = startchange.offset();
   $(document).scroll(function() { 
      scroll_start = $(this).scrollTop();
      if(scroll_start > offset.top) {
          $('.header-wrapper ').css('margin-top', '0px');
          $('#shopify-section-announcement-bar').css('display', 'none');
         $('.header__heading-mob-logo').css('display', 'block');
          $('.header__heading-logo').css('display', 'none');
       } else {

  $('.header__heading-mob-logo').css('display', 'none');
          $('.header__heading-logo').css('display', 'block');
       }
   });




});
